export default "__VITE_ASSET__ae1a3fa9__"